export enum CommunicationMethodEnum {
    email = 1,
    mobile,
    main
}
